import React from 'react';
import Axios from 'axios';
import { Link, Redirect } from 'react-router-dom';
import { API_HOST, axiosInstance, axiosRequestWithAuth } from './../../constants/server.constant';

export default class BillingNav extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            userId: localStorage.getItem("userId"),
            isSecurityShow: false
        };
    }

    componentDidMount() {
        console.log(this.props);
        this.checkTwoFAStatus();
    }
    checkTwoFAStatus = () => {
        axiosInstance.get(API_HOST + "/user/getuserinfo/" + this.state.userId, axiosRequestWithAuth).then(resp => {

            let info = resp.data.body;
            if(info && info.hasOwnProperty("parent_user_id")) {
                if(info.is_2fa_enabled == 1) {
                    this.setState({
                        isSecurityShow: true
                    });
                }
                else {
                    this.setState({
                        isSecurityShow: false
                    });
                }
            }
            else {
                this.setState({
                    isSecurityShow: true
                });
            }

        }).catch(err => {
            console.log(err);
        });
    };

    render() {

        let roleid = localStorage.getItem("roleId");
        let geturl = window.location.href;

        return (
            <aside className="accountModule_nav">
                <div className="settingModule_bg_shadow"></div>
                <ul className='billingNav'>
                    <li className={ geturl.indexOf("creditcard") !== -1 ? "acc_updateCard active" : "acc_updateCard" } style={ { display: roleid == 2 ? "block" : "none" } }>
                        <Link to="/billing/creditcard" onClick={ () => this.props.addNavclassOnNavClick('acc_creditCardUpdate') }  >
                            <span className="svg_wrap"> <svg x="0px" y="0px" viewBox="0 0 16.9 13.5" enableBackground="new 0 0 16.9 13.5" xmlSpace="preserve">
                                <path fillRule="evenodd" clipRule="evenodd" fill="#868686" d="M15.2,12.8H1.7c-0.7,0-1.3-0.6-1.3-1.3V6.8v-1v-1v-1V2  c0-0.7,0.6-1.3,1.3-1.3h13.4c0.7,0,1.3,0.6,1.3,1.3v1.7v1v6.7C16.5,12.2,15.9,12.8,15.2,12.8z M15.4,1.8h-14v2h14V1.8z M15.4,4.8  h-14v1h5v1h-5v5h14V4.8z M9.4,7.8c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S8.9,7.8,9.4,7.8z M12.4,7.8c0.6,0,1,0.4,1,1s-0.4,1-1,1  s-1-0.4-1-1S11.9,7.8,12.4,7.8z"></path>
                            </svg> </span>Credit card
                        </Link>

                    </li>
                    <li className={ geturl.indexOf("billinghistory") !== -1 ? "acc_billHistory active" : "acc_billHistory" } style={ { display: roleid == 2 ? "block" : "none" } } >

                        <Link to="/billing/billinghistory" onClick={ () => this.props.addNavclassOnNavClick('acc_billHistory') } >
                            <span className="svg_wrap"> <svg x="0px" y="0px" viewBox="0 0 16.9 18.1" enableBackground="new 0 0 16.9 18.1" xmlSpace="preserve">
                                <g>
                                    <path fillRule="evenodd" clipRule="evenodd" fill="#868686" d="M15.2,17.3L15.2,17.3h-2.9h-1H1.8c-0.7,0-1.2-0.5-1.2-1.2V2   c0-0.7,0.5-1.2,1.2-1.2H13c0.7,0,1.2,0.5,1.2,1.2v8.5h1.9v5.3C16.1,16.4,15.7,17.1,15.2,17.3z M13.2,12.4v-1.9V1.8H1.6v14.5h9.7   h1.9h0.1c-0.1-0.2-0.1-0.3-0.1-0.5V12.4z M15.2,11.5h-1v4.4c0,0.3,0.2,0.5,0.5,0.5c0.3,0,0.5-0.2,0.5-0.5V11.5z"></path>
                                    <text transform="matrix(1 0 0 1 4.2444 12.8454)" fill="#868686" fontFamily="'Roboto-Medium'" fontSize="10.2565px">$</text>
                                </g>
                            </svg> </span>Billing History
                        </Link>

                    </li>

                    <li className={ geturl.indexOf("myinvoices") !== -1 ? "acc_billHistory active" : "acc_billHistory" } style={ { display: roleid == 2 ? "block" : "none" } }  >
                        <Link to="/billing/myinvoices" onClick={ () => this.props.addNavclassOnNavClick('acc_myInvoice') }>
                            <span className="svg_wrap"> <svg x="0px" y="0px" viewBox="0 0 16.9 18.3" enableBackground="new 0 0 16.9 18.3" xmlSpace="preserve">
                                <g>
                                    <path fillRule="evenodd" clipRule="evenodd" fill="#868686" d="M15.8,4.9v0.7v10.8c0,0.7-0.5,1.2-1.2,1.2H3   c-0.7,0-1.2-0.5-1.2-1.2V1.8c0-0.7,0.5-1.2,1.2-1.2h8.7L15.8,4.9z M10.8,1.5h-8v15h12v-11h-3h-1v-1V1.5z M11.8,2.1v2.4h2.4   L11.8,2.1z M12.8,12.5h-8v-1h8V12.5z M12.8,14.5h-8v-1h8V14.5z"></path>
                                    <text transform="matrix(1 0 0 1 6.9149 9.9641)" fill="#868686" fontFamily="'Roboto-Medium'" fontSize="6px">$</text>
                                </g>
                            </svg> </span>My Invoices
                        </Link>
                    </li>



                </ul >
            </aside >
        );
    }
}